"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDayToDate = exports.dateFromString = exports.validDateString = void 0;
var date_fns_1 = require("date-fns");
var utils_1 = require("../../../utils");
var dateFormat_1 = require("../../../constants/dateFormat");
function validDateString(sourceDate) {
    if (sourceDate === '') {
        return date_fns_1.format(new Date(), dateFormat_1.defaultDateFormat);
    }
    return sourceDate;
}
exports.validDateString = validDateString;
/**
 * Parses the provided string date, based on whether it detects that it's a simple
 * date or not.
 *
 * @param source - The source string to parse
 */
function dateFromString(source) {
    return utils_1.isSimpleDate(source)
        ? date_fns_1.parse(source, dateFormat_1.defaultDateFormat, new Date())
        : new Date(source);
}
exports.dateFromString = dateFromString;
/**
 * Add days to Date
 * @param date
 * @param days
 * @returns
 */
function addDayToDate(date, days) {
    date.setDate(date.getDate() + days);
    date.setHours(0, 0, 0, 0);
    return new Date(date);
}
exports.addDayToDate = addDayToDate;
//# sourceMappingURL=dateFormats.js.map